import { TableData } from '../table/Table';
import { IdType, Row } from 'react-table';
import { DateRangeValue } from './DateRangePicker';

export interface DateFilter {
  start: DateRangeValue;
  end: DateRangeValue;
}

export const dateRange =
  <Data extends TableData>(columnId: keyof Data) =>
  (rows: Row<Data>[], columnIds: Array<IdType<Data>>, filterValue: DateFilter): Row<Data>[] => {
    return rows.filter((row) => {
      const { start, end } = filterValue;
      const originalDate = row.original[columnId];
      const date = Date.parse(originalDate);
      if (!start && end) {
        return Date.parse(end) >= date;
      }
      if (start && !end) {
        return Date.parse(start) <= date;
      }
      if (start && end) {
        return Date.parse(start) <= date && Date.parse(end) >= date;
      }
      return true;
    });
  };
